export default __webpack_public_path__ + "static/media/password-banner.0a21f707.svg";